import React, { useState } from "react";
import { purchaseLoyaltyCard, renewLoyaltyCard } from "../../Api/Api";
import { useNotification } from "../Notification/NotificationContext";

const LoyaltyCardModal = ({ show, customerId, onClose, onSuccess, existingCard }) => {
    const [selectedCard, setSelectedCard] = useState("GOLD");
    const { showNotification } = useNotification();

    if (!show) return null;

    const isRenew = !!existingCard; // ✅ If card exists, treat as renew

    const handleSubmit = async () => {
        try {
            if (isRenew) {
                await renewLoyaltyCard(customerId, selectedCard);
                showNotification("Renewed Successfully!", "success");
            } else {
                await purchaseLoyaltyCard(customerId, selectedCard);
                showNotification("Activated Successfully!", "success");
            }

            onSuccess();
            onClose();
        } catch (error) {
            showNotification(error.message || "Failed to process request", "error");
        }
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
            <div className="bg-white rounded-lg shadow-xl w-96 p-6">
                <h2 className="text-xl font-semibold text-gray-800 mb-4">
                    {isRenew ? "Renew Loyalty Card" : "Purchase Loyalty Card"}
                </h2>

                {!isRenew && (
                    <>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Select Card Type
                        </label>
                        <select
                            value={selectedCard}
                            onChange={(e) => setSelectedCard(e.target.value)}
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 mb-4"
                        >
                            <option value="GOLD">Tamaria Gold Card</option>
                        </select>
                    </>
                )}

                <div className="flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSubmit}
                        className="px-4 py-2 rounded-lg bg-yellow-600 hover:bg-yellow-700 text-white"
                    >
                        {isRenew ? "Renew (₹1000)" : "Purchase (₹1000)"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LoyaltyCardModal;
